export default {
  slogan: 'Playturbo',
  loginToPt: 'Playturboにログイン',
  loginPopbox: {
    title: 'ヒント',
    content: 'ログインに失敗しました。もう一度お試しください。',
    confirm: '確認',
  },
  form: {
    userPlaceHolder: 'ユーザー名を入力してください',
    userRequiredText: 'ユーザー名またはメールアドレスは空欄にできません',
    passwordPlaceHolder: 'パスワードを入力してください',
    passwordRequiredText: 'パスワードは空欄にできません',
    verifyCodeRequiredText: 'キャプチャコードは空欄にできません',
    loginText: 'ログイン',
    loginSuccessText: 'ログインしました',
    forgetText: 'パスワードを忘れた場合',
    registerText: '無料登録',
    privacyLabel: {
      readAgreed: '確認の上、同意します',
      userAgreement: '利用規約',
      membershipAgreement: 'Playturbo会員サービス契約',
      and: 'と',
      privacyAgreement: 'プライバシーポリシー',
      dpaTitle: '「データ保護に関する補足」',
      dpaDesc:
        '私は、これらの音声サンプルをアップロードするためのすべての必要な権利または同意を得ており、プラットフォーム生成のコンテンツを違法、不正または有害な目的に使用しないことを保証します。',
    },
    privacyRequiredText: 'プライバシーポリシーに同意してください。',
  },
  swiper: {
    psTitle: 'プレイツール、ゼロのハードルで簡単に作成可能なツール',
    videoTitle: 'ビデオツール、大量の作品基地を生成',
    recordTitle: 'スクリーンレコーディングツール、手を解放するのに役立ちます',
    psLabel:
      'コードの基礎は不要で、簡単にプレイアブル広告を自作<br/>多言語、複数チャネル一括パッケージング、広告の展開がより効果的に。高品質なテンプレートで今までにない制作体験を提供。',
    videoLabel:
      '大量の商用アセットライブラリ、すべてのデザイン効果に対応<br/>要素フラグメントを一括して組み合わせ、一度の操作で複数の作品を出力<br/>スマートな吹き出し、迅速な字幕の設定、ワンストップで素早く制作が完了。',
    recordLabel:
      'パラメータのカスタム設定、レベルの内容を自由に組み合わせる<br/>一度の記録操作で複数のバージョンを簡単に出力',
  },
  about: 'について',
  register: '登録',
}
